module.exports = __webpack_public_path__ + "img/04.3aea95bb.jpg";